import {
  analyticsBrowser,
  setupAnalytics,
} from 'mex_components/app/scripts/analytics/index';
import fetchAuthenticatedUser from '../auth/fetch_authenticated_user';
import getUserTraits from './get_user_traits';
import supplementalContextHelpers from './supplemental_context_helpers';

function initializeAnalytics() {
  setupAnalytics({
    amplitudeGuidesAndSurveysApiKey: window.components?.amplitude_api_key,
    segmentWriteKey: window.components?.segment_write_key,
    supplementalContextHelpers,
  });

  analyticsBrowser.ready(async () => {
    const me = await fetchAuthenticatedUser().catch(() => undefined);
    if (me) {
      const userTraits = getUserTraits(me);
      if (userTraits) {
        await analyticsBrowser.identify(userTraits.user_id, userTraits);
      }
    }
  });
}

export default initializeAnalytics;
